import { createHashHistory, createBrowserHistory } from 'history';

// Browser history
const userAgent = navigator.userAgent.toLowerCase();
const history = userAgent.indexOf('electron') > -1 ? createHashHistory() : createBrowserHistory();
history.location.firstPage = true;
export default history;



// WEBPACK FOOTER //
// ./data/common/history.js